import etReferenceDataConfig from '@/api/config/etReferenceDataConfig'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'

function useEtReferenceById(interfaceId: any, etReferenceId: any) {
  return useQuery(
    [[queryKeys.etReference], etReferenceId, interfaceId],
    async () => {
      if (!interfaceId || !etReferenceId) return null
      const { data } = await etReferenceDataConfig.getById(
        interfaceId.toString(),
        etReferenceId.toString(),
      )
      if (!data) return null

      return data
    },
  )
}

export default useEtReferenceById
